module.exports = __webpack_public_path__ + "img/crystal-ball.10331fc1.svg";